import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Field } from 'redux-form/immutable';
import moment from 'moment';
import { FormHelperText } from '@material-ui/core';

import FormDateSelector from 'retired/FormDateSelector';

export const RegistrationDeadline = ({
  isNew,
  endingAt,
  timeZone,
  placeholder = 'Deadline Date',
  placeholderTime = 'Time',
}: {
  isNew: boolean;
  endingAt: object;
  timeZone?: string;
  placeholder?: string;
  placeholderTime?: string;
}) => (
  <div style={{ marginTop: 20 }}>
    <FormControl style={{ width: '100%', height: 17 }}>
      <InputLabel shrink>Registration Deadline</InputLabel>
    </FormControl>
    <Field
      name="registrationEndingAt"
      component={FormDateSelector}
      isPreviousDateDisabled
      displayTimeZone={!!timeZone}
      minDate={isNew ? moment() : undefined}
      maxDate={endingAt}
      timeZone={timeZone}
      placeholder={placeholder}
      placeholderTime={placeholderTime}
    />
    <FormHelperText>
      After this date and time, registration to this event is disabled.
    </FormHelperText>
  </div>
);
